import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postHideColumns = createApi(`PostHideColumnsSlice`,"POST");

const PostHideColumnsSlice = createSlice({
  name: 'PostHideColumnsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postHideColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postHideColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postHideColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostHideColumnsSlice.reducer;